import { FC } from "react";
import SRC_1 from "./image/1.jpg";
import SRC_2 from "./image/2.jpg";

export const LoveLineTemplate2: FC = () => {
  return (
    <div className="template-2">
      <div
        className="date"
        data-parallax="3"
        data-animation-direction="fade"
        data-animation-delay="250"
      >
        <span className="neela-style">
          <span className="h-lines"></span>
          <span className="v-lines"></span>22 May
        </span>
      </div>

      <div
        className="image-1"
        data-parallax="-2"
        data-animation-direction="from-left"
        data-animation-delay="250"
      >
        <img src={SRC_2} alt="" />
      </div>

      <div
        className="image-2"
        data-parallax="4"
        data-animation-direction="from-right"
        data-animation-delay="250"
      >
        <img src={SRC_1} alt="" />
      </div>

      <div
        className="description-wrapper"
        data-parallax="-5"
        data-animation-direction="from-bottom"
        data-animation-delay="250"
      >
        <div
          className="description"
          data-parallax="-6"
          data-animation-direction="from-bottom"
          data-animation-delay="250"
        >
          <div className="neela-style">
            <span className="h-lines"></span>
            <span className="v-lines"></span>
            <h4 style={{ fontWeight: 300 }}>She said Yes!</h4>
            <p>
              When I got down on one knee to propose to Nastya, she thought my
              nervousness was because I was afraid of falling into the water
              nearby. But in truth, all of my anxiety was about making sure the
              moment was as magical as she deserved, and hoping with all my
              heart that she would say "yes."
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
